import React from "react";
import "./Wind.css";

export default function Wind() {
    return (
        <div className="Wind">
            <form>
                <div className="row">
                    <div className="col-8">
                        <input
                            type="search"
                            placeholder="Enter a city.."
                            className="form-control"
                            autoFocus="on"
                        />
                    </div>
                    <div className="col-4">
                        <input
                            type="submit"
                            value="Search"
                            className="btn w-100"
                        />
                    </div>      
                </div>   
            </form>       
            <div className="row">
                <div className="col-6">
                    <span>  
                        <ul className="current-data mt-5">
                            <li><h1><strong>5</strong></h1> <h5>Km/h  |  mph</h5></li>
                            <li>South 6</li>
                            <br/>
                            <li><h2>New York</h2></li>
                            <li><h4>Fri, 3:18pm</h4></li>
                        </ul>
                    </span>
                </div>
                <div className="col-6">
                    <span>
                        <iframe
                        src="https://giphy.com/embed/vcBbqYm9lQLfIdxNSw"
                        width="192"
                        height="240"
                        frameborder="0"
                        title="giphy"
                        className="giphy-embed mt-5"
                        allowfullscreen
                        ></iframe>
                    <p>
                        <a
                            href="https://giphy.com/gifs/crptc-child-crypticchild-crptcchild-vcBbqYm9lQLfIdxNSw" target="_blank" rel="noreferrer"
                        > {" "}</a>
                    </p>
                    </span>
                </div>
            </div>
        </div>
    );
}